/** Feuille « Filtres » — EF-RBK-003. Le filtrage ne modifie jamais les calculs. */

import type { JSX } from 'preact';
import { CATEGORIES } from '../../core/categories';
import { SHEETS } from '../labels';
import { Sheet } from './Sheet';
import { closeSheet, parameters, resetFilters, setDisplay, toggleHiddenCategory } from '../state';

export function FilterSheet(): JSX.Element {
  const display = parameters.value.display;
  const hidden = new Set(display.hiddenCategories);

  return (
    <Sheet title={SHEETS.filters} onClose={closeSheet}>
      <p class="muted">Le filtrage ne modifie ni les calculs, ni les POI enregistrés, ni les exports.</p>

      <fieldset>
        <legend>Catégories affichées</legend>
        {CATEGORIES.map((definition) => (
          <label class="checkbox" key={definition.key}>
            <input
              type="checkbox"
              checked={!hidden.has(definition.key)}
              onChange={() => {
                toggleHiddenCategory(definition.key);
              }}
            />
            <span>{definition.label}</span>
          </label>
        ))}
      </fieldset>

      <fieldset>
        <legend>Filtres particuliers</legend>
        <label class="checkbox">
          <input
            type="checkbox"
            checked={display.pinnedOnly}
            onChange={(event) => {
              setDisplay({ ...display, pinnedOnly: (event.currentTarget as HTMLInputElement).checked });
            }}
          />
          <span>N’afficher que les POI épinglés</span>
        </label>
        <label class="checkbox">
          <input
            type="checkbox"
            checked={display.excludedOnly}
            onChange={(event) => {
              setDisplay({ ...display, excludedOnly: (event.currentTarget as HTMLInputElement).checked });
            }}
          />
          <span>N’afficher que les POI exclus</span>
        </label>
      </fieldset>

      <div class="actions">
        <button type="button" onClick={resetFilters}>
          Réinitialiser les filtres
        </button>
      </div>
    </Sheet>
  );
}
